export default {
  NONE: "syncCustomField_NONE",
  CREATE: "syncCustomField_CREATE",
  ULYSSES_NOTE: "syncCustomField_ULYSSES_NOTE",
  ULYSSES_KEYWORD: "syncCustomField_ULYSSES_KEYWORD",
  TITLE: "title",
  SYNOPSIS: "synopsis",
  LABEL: "label",
  STATUS: "status"
};
